import React, { Component, PropTypes } from 'react';
import { formatDate, formatShortDate, elapsedTimeFrom } from '../../../utils/DateUtils';
import { authorsToString } from '../../../utils/NewsUtils';

const LONG_DATE_FORMAT = 'dddd, MMMM Do Y, h:mm a z';
const MAX_DURATION_DISPLAY_DIFFERENT_TIME_IN_SECOND = 60 * 60;

/**
 * Class representing a timestamp of an element on the page, with the option of displaying the authors
 */
class Timestamp extends Component {
  static propTypes = {
    publishDate: PropTypes.string,
    displayShortDateTime: PropTypes.bool,
    showElapsedTime: PropTypes.bool,
    authors: PropTypes.node
  }

  static defaultProps = {
    showElapsedTime: false,
    displayShortDateTime: false
  }

  _getFormatedDay(dayString) {
    const { showElapsedTime, displayShortDateTime } = this.props;
    const dateToCaculate = new Date(dayString);
    const now = new Date();
    const elapsedTimeInMiliSecs = now - dateToCaculate;

    if (showElapsedTime && elapsedTimeInMiliSecs < MAX_DURATION_DISPLAY_DIFFERENT_TIME_IN_SECOND * 1000) {
      return `${elapsedTimeFrom(dateToCaculate)} ago`;
    } else {
      if (displayShortDateTime) {
        return formatShortDate(dayString);
      } else {
        return formatDate(dayString, LONG_DATE_FORMAT);
      }
    }
  }

  render() {
    const { publishDate, authors } = this.props;

    return (
      <div className="Timestamp">
        <div className="Timestamp-text">
          {publishDate ? <span className="Timestamp-time">{this._getFormatedDay(publishDate)}</span> : null}
          {publishDate && (authors && authors.length) ? <span className="Timestamp-connector">{' by '}</span> : ''}
          {(authors && authors.length) ? <span className="Timestamp-author">{authorsToString(authors)}</span> : null}
        </div>
      </div>
    );
  }
}

export default Timestamp;



// WEBPACK FOOTER //
// ./app/components/custom/griffin/Timestamp.js